import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { GridModule } from '../grid/grid.module';
import { NavigationCoreModule } from '../navigation-core/navigation-core.module';
import { EventPickComponent } from '../option-pick/event-pick.component';
import { TabBarModule } from '../tab-bar/tab-bar.module';
import { NextToGoEventComponent } from './next-to-go-event/next-to-go-event.component';
import { NextToGoOptionGroupComponent } from './next-to-go-option-group/next-to-go-option-group.component';
import { NextToGoShowMoreComponent } from './next-to-go-show-more/next-to-go-show-more.component';

@NgModule({
    imports: [
        CommonModule,
        NavigationCoreModule,
        TabBarModule,
        GridModule,
        CompetitionLogoComponent,
        FontResizerComponent,
        TrustPipe,
        EventPickComponent,
        IconCustomComponent,
        NativePriceFormatterPipe,
    ],
    declarations: [NextToGoEventComponent, NextToGoShowMoreComponent, NextToGoOptionGroupComponent],
    exports: [NextToGoEventComponent, NextToGoShowMoreComponent],
})
export class NextToGoModule {}
